module.exports = "/static/assets/74c2f1a6834785b463915a2886026718.png";